import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async (options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.common.getAuthorInfo, {}, options);
    if (error) return { error, status };
    return content || {};
};
